export class InvalidPhoneError extends Error {
  constructor() {
    super('Número de telefone inválido')
    this.name = 'InvalidPhoneError'
  }
}
